/**
 * Mensagens de erro do POST /alerts/ (criação de alerta).
 *
 * O backend responde assim que o alerta é gravado; e-mails e push saem em
 * segundo plano. Um timeout/502 aqui significa que o alerta PODE ter sido
 * criado — o usuário deve conferir a lista antes de reenviar.
 */

/** Tempo máximo de espera pela resposta da criação (a API não espera SMTP). */
export const CREATE_ALERT_TIMEOUT_MS = 60000;

const MAYBE_CREATED_MESSAGE =
  "O servidor demorou a responder e não confirmou o cadastro. O alerta pode ter sido criado: confira a lista de alertas antes de tentar novamente.";

const GATEWAY_STATUSES = new Set([502, 503, 504]);

function firstMessage(value) {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return firstMessage(value[0]);
  if (typeof value === "object") {
    for (const v of Object.values(value)) {
      const msg = firstMessage(v);
      if (msg) return msg;
    }
  }
  return "";
}

export function getCreateAlertErrorMessage(error) {
  const status = error?.response?.status;
  const data = error?.response?.data;

  if (!error?.response || error?.code === "ECONNABORTED" || GATEWAY_STATUSES.has(status)) {
    return MAYBE_CREATED_MESSAGE;
  }
  if (status === 401) {
    return "Sessão expirada. Faça login novamente.";
  }

  const linkedMsg = firstMessage(data?.alert_request);
  if (linkedMsg) {
    return /já existe um alerta/i.test(linkedMsg)
      ? "Já existe um alerta vinculado a esta solicitação (pode ter sido criado em uma tentativa anterior). Confira a lista de alertas."
      : linkedMsg;
  }

  return (
    data?.message ||
    data?.detail ||
    data?.error ||
    firstMessage(data) ||
    "Erro ao cadastrar alerta."
  );
}
